import { Theme } from "@mui/material";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { FC } from "react";

interface LightTooltipProps extends TooltipProps {
  theme?: Theme;
}

export const LightTooltip: FC<LightTooltipProps> = ({
  children,
  theme,
  ...props
}) => {
  return (
    <Tooltip
      enterTouchDelay={0}
      leaveTouchDelay={6000}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: theme?.palette.surface?.light,
            color: theme?.palette.textMain.dark2,
            boxShadow: theme?.shadows[1],
            padding: theme?.spacing(1.25) + " " + theme?.spacing(2.5),
          },
        },
        arrow: {
          sx: {
            color: theme?.palette.surface?.light,
          },
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};
